<template>
    <div class="fixedLeft">
        <div
            v-if="!isLogin && false"
            class="fixedLeftExhibitor fixedLeftDiv pointer"
            @click="goExhibitor"
        >
            <a
                class="image-link-a"
            >
                <img :src="exhibitor">
                <p class="fixedLeftP">{{ $t('homes.exhibitor') }}</p>
            </a>
        </div>
        <div
            v-if="!isLogin"
            class="fixedLeftPerson fixedLeftDiv pointer"
            @click="goPerson"
        >
            <a
                class="image-link-a"
                onclick="return false"
            >
                <img :src="person">
                <p class="fixedLeftP">{{ $t('homes.person') }}</p>
            </a>
        </div>
        <div
            class="fixedLeftPerson fixedLeftDiv pointer"
            @click="goMessage"
        >
            <img :src="message">
            <p class="fixedLeftP">{{ $t('Online Service') }}</p>
        </div>
        <div
            class="fixedLeftGoTop fixedLeftDiv pointer"
            @click="goTopScroll"
        >
            <img :src="goTop">
        </div>
        <!-- 聊天窗口 -->
        <v-chat-width-employee-tim v-if="isTIM" />
        <v-chat-width-employee v-if="!isTIM" />
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
// import exhibitor from '@/assets/img/homeImages/exhibitor.png'
// import person from '@/assets/img/homeImages/person.png'
// import message from '@/assets/img/homeImages/message.png'
// import goTop from '@/assets/img/homeImages/goTop.png'
import exhibitor from '@/assets/homeImages/exhibitor.png'
import person from '@/assets/homeImages/person.png'
import message from '@/assets/homeImages/message.png'
import goTop from '@/assets/homeImages/goTop.png'
import ChatWithEmployeeTim from '@/components/Tim/ChatWithEmployee'
import ChatWithEmployee from '@/components/chat/ChatWithEmployee'

export default {
    components: {
        'v-chat-width-employee': ChatWithEmployee,
        'v-chat-width-employee-tim': ChatWithEmployeeTim
    },
    data() {
        return {
            exhibitor,
            person,
            message,
            goTop
        }
    },
    computed: {
        ...mapState('chat', [ 'touristService' ]),
        ...mapState({
            customerServiceInfo: state => state.timStore.customerServiceInfo,
            currentUserProfile: state => state.timStore.currentUserProfile,
            conversationList: state => state.timStore.conversationList
        }),
        ...mapGetters([  'isLogin', 'config', 'isTIM' ])
    },
    methods: {
        goExhibitor() {
            if (!this.ActorNoTodo()) return
            window.PC.$RangersEvent("Homepagesuspension_Exhibitors_Click")
            this.$store.commit('SET_SUBJECTTYPE', 'ACTOR')
            this.loginSource('/login/actor')
        },
        goPerson() {
            window.PC.$RangersEvent("Homepagesuspension_visitor_Click")
            this.$store.commit('SET_SUBJECTTYPE', 'VISITOR')
            this.loginSource('/login/person')
        },
        async goMessage() {
            if (this.$store.getters.isLogin) {
                if (!this.$store.getters.isSDKReady) {
                    console.log('去注册sdk')
                    await this.$store.dispatch('getOnlineCustomer', this.$store.getters.isLogin)
                    console.log('注册完成')
                } else {
                    console.log('已注册sdk')
                }
            }
            console.log('继续往下走')
            if (this.isTIM) {
                window.PC.$RangersEvent("Homepagesuspension_OnlineService_Click")
                console.log('准备注册sdk*******', !this.$store.getters.isSDKReady)
                if (!this.$store.getters.isSDKReady) {
                    console.log('去注册sdk---')
                    await this.$store.dispatch('getOnlineCustomer', this.$store.getters.isLogin)
                    console.log('注册完成---')
                }
                console.log('继续往下走---', this.customerServiceInfo, !this.$store.getters.isSDKReady)
                // 在线客服IM id
                const userID = this.customerServiceInfo?.id || ''
                if (userID) {
                    // await this.$store.commit('toogleChatDialog')
                    let conversationID = `C2C${userID}`
                    if (userID !== '@TIM#SYSTEM') {
                        // 判断是否为在线客服
                        if (this.currentUserProfile.userID === userID) {
                            conversationID = this.conversationList[0].conversationID
                        }
                        await this.$store.dispatch('checkoutConversation', conversationID)
                            .then(async() => {
                                console.log('===========拉取会话列表成功===========')
                                await this.$store.commit('toogleChatDialog')
                            }).catch(async(imError) => {
                                // const message = JSON.parse(JSON.stringify(imError)).message || this.$t('拉取会话失败')
                                const message = this.$t('拉取会话失败')
                                console.log('imError--->', JSON.parse(JSON.stringify(imError)).message)
                                // console.log('===========拉取会话列表成功失败3333333333===========', message)
                                await this.$store.commit('showMessage', {
                                    message,
                                    type: 'warning'
                                })
                            })
                    }
                    return
                } else {
                    return false
                }
            }
            // 登录之后不刷新页面  重新登录环信分配角色
            await this.$store.dispatch('chat/getOnlineCustomer', this.isLogin)

        },
        goTopScroll() {
            cancelAnimationFrame(timer)
            var timer = requestAnimationFrame(function fn() {
                var oTop = document.body.scrollTop || document.documentElement.scrollTop
                if (oTop > 0) {
                scrollBy(0, -50)
                timer = requestAnimationFrame(fn)
                } else {
                cancelAnimationFrame(timer)
                }
            })
        },
    }
}
</script>

<style lang="scss" scoped>
.fixedLeft {
    padding: 8px 0;
    position: fixed;
    right: 15px;
    bottom: 50px;
    width: 70px;
    z-index: 1202;
    
    border-radius: 5px;

    img {
        width: 40px;
        height: 40px;
    }

    .fixedLeftDiv {
        padding: 8px;
        text-align: center;
        cursor: pointer;
    }

    .fixedLeftP {
        font-size: 10px;
        padding: 10px 0;
        border-bottom: 1px solid rgba(0, 0, 0, 0.10);
        text-align: center;
    }

    .fixedLeftGoTop {
        padding-bottom: 8px;
    }
}
</style>
